import { createSlice } from "@reduxjs/toolkit";
import { SoundAlerts } from "src/modules/sound-alerts/SoundAlerts";

const initialState = {
  enabled: true,
  selectedSound: SoundAlerts.melodic.name,
  repeat: true,
  delay: 0
};

const soundAlertsSlice = createSlice({
  name: "soundAlerts",
  initialState,
  reducers: {
    toggleEnabled(state) {
      state.enabled = !state.enabled;
    },
    selectSound(state, { payload }) {
      state.selectedSound = payload;
    },
    setRepeat(state, { payload }) {
      state.repeat = payload;
    },
    setDelay(state, { payload }) {
      state.delay = payload;
    }
  }
});

export { soundAlertsSlice };
export default soundAlertsSlice.reducer;
